<section class="secondary-drawer-container">
    <button class="drawer-close-btn mat-elevation-z0" mat-mini-fab aria-label="Close" (click)="dismiss()">
        <mat-icon>close</mat-icon>
    </button>
    <h5 class="drawer-title">Image Viewer</h5>
</section>
<div class="custom-scroller">
    <div>
        <div class="invoice-img-tag" *ngIf="showBeforeAfterTag == true && isImage">
            <span *ngIf="isAfter">After</span>
            <span *ngIf="!isAfter">Before</span>
          </div>
        <img src="{{file}}" style="width: 100%">
    </div>
    <div class=" text-left" *ngIf="comment">
        <h3 class="font-12 font-medium text-left font-poppins mt-5 mb-2">Comments</h3>
        <hr class="mt-2" />
        <div [innerHTML]="comment"></div>
    </div>
</div>